import { useState, useEffect } from 'react';

export const useOfflineSync = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingSubmissions, setPendingSubmissions] = useState([]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Load pending submissions from localStorage
    const stored = localStorage.getItem('pendingSubmissions');
    if (stored) {
      setPendingSubmissions(JSON.parse(stored));
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const addPendingSubmission = submission => {
    const newSubmission = {
      ...submission,
      id: Date.now().toString(),
      timestamp: new Date().toISOString(),
    };

    const updated = [...pendingSubmissions, newSubmission];
    setPendingSubmissions(updated);
    localStorage.setItem('pendingSubmissions', JSON.stringify(updated));

    // Trigger background sync if available
    if ('serviceWorker' in navigator && 'sync' in window.ServiceWorkerRegistration.prototype) {
      navigator.serviceWorker.ready.then(registration => {
        return registration.sync.register('quiz-submission');
      });
    }
  };

  const removePendingSubmission = id => {
    const updated = pendingSubmissions.filter(sub => sub.id !== id);
    setPendingSubmissions(updated);
    localStorage.setItem('pendingSubmissions', JSON.stringify(updated));
  };

  return {
    isOnline,
    pendingSubmissions,
    addPendingSubmission,
    removePendingSubmission,
  };
};
